import { useState } from "react";
import { Box, Button, Container, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";

export default function PropertySearch() {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [activeTab, setActiveTab] = useState("Buy");

  const handleSearch = () => {
    if (searchText) {
      switch (activeTab) {
        case "Developers":
          // For the Developers tab, search by query
          console.log("Searching for developers:", searchText);
          navigate(
            `${ROUTES.DEVELOPERS}?query=${encodeURIComponent(searchText)}`
          );
          break;

        case "Areas":
          // For the Areas tab, handle search logic accordingly (e.g., search by area)
          console.log("Searching for areas:", searchText);
          navigate(`${ROUTES.AREAS}?query=${encodeURIComponent(searchText)}`);
          break;

        case "Buy":
          // For the Buy tab, handle search logic for buyable properties
          console.log("Searching for properties to buy:", searchText);
          navigate(`${ROUTES.BUY}?query=${encodeURIComponent(searchText)}`);
          break;

        case "Rent":
          // For the Rent tab, handle search logic for rentable properties
          console.log("Searching for properties to rent:", searchText);
          navigate(`${ROUTES.RENT}?query=${encodeURIComponent(searchText)}`);
          break;

        default:
          console.log("No active tab or invalid tab");
      }
    }
  };

  // Custom styled components using inline styling
  const TabButton = ({ active, children, ...props }) => (
    <Button
      {...props}
      sx={{
        backgroundColor: active ? "#C10E14" : "#fff",
        fontFamily: "'Poppins', sans-serif",
        color: active ? "#fff" : "#000",
        padding: "12px 24px",
        borderRadius: "50px",
        fontWeight: 600,
        textTransform: "none",
        margin: "0 4px",
        "&:hover": {
          backgroundColor: active ? "#C10E14" : "#f5f5f5",
        },
      }}
    >
      {children}
    </Button>
  );

  return (
    <Box
      sx={{
        // background: "linear-gradient(rgba(210, 180, 140, 0.7), rgba(210, 180, 140, 0.7)), url('/placeholder.jpg')",
        backgroundSize: "cover",
        paddingTop: "32px",
        // paddingBottom: "50px",
        position: "relative",
      }}
    >
      {/* Navigation Tabs */}
      <Container
        maxWidth="md"
        sx={{
          mb: 4,
          textAlign: "center",
          // backgroundColor: "red",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            bgcolor: "rgba(255, 255, 255, 0.6)", // 80% opacity white
            borderRadius: "50px",
            padding: "4px",
            boxShadow: "0 4px 14px rgba(0, 0, 0, 0.1)",
            border: "1px solid #e0e0e0",
          }}
        >
          <TabButton
            active={activeTab === "Rent"}
            onClick={() => setActiveTab("Rent")}
          >
            Rent
          </TabButton>
          <TabButton
            active={activeTab === "Buy"}
            onClick={() => setActiveTab("Buy")}
          >
            Buy
          </TabButton>
          <TabButton
            active={activeTab === "Areas"}
            onClick={() => setActiveTab("Areas")}
          >
            Areas
          </TabButton>
          <TabButton
            active={activeTab === "Developers"}
            onClick={() => setActiveTab("Developers")}
          >
            Developers
          </TabButton>
        </Box>
      </Container>

      {/* Search Bar */}
      <Container maxWidth="md" sx={{ mb: 3 }}>
        <Box
          sx={{
            position: "relative",
            mb: 2,
            bgcolor: "#fff",
            borderRadius: "50px",
            overflow: "hidden",
            boxShadow: "0 4px 14px rgba(0, 0, 0, 0.1)",
          }}
        >
          <TextField
            fullWidth
            placeholder="Search by area or project name or location"
            variant="outlined"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "50px",
                pr: 15, // Make room for the button
                "& fieldset": {
                  border: "none",
                },
              },
              "& .MuiInputBase-input": {
                padding: "16px 24px",
                height: "24px",
              },
            }}
          />

          <Button
            onClick={handleSearch}
            sx={{
              position: "absolute",
              fontFamily: "'Poppins', sans-serif",
              right: "6px",
              top: "6px",
              bottom: "6px",
              minWidth: "100px",
              backgroundColor: "#C10E14",
              color: "#fff",
              borderRadius: "50px",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#A30B11",
              },
            }}
          >
            Search
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
